import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SearchableItem } from '../../../model/interface/searchable.item';
import { ClientUser } from 'src/app/model';

@Component({
  selector: 'create-new-client-user-modal',
  templateUrl: './create-new-client-user.modal.html',
  styleUrls: ['./create-new-client-user.modal.scss']
})

export class CreateNewClientUserModal implements OnInit, OnDestroy {
  subject: Subject<SearchableItem>;
  subscription: any;
  isEdit = false;
  manageFlag = false;
  clientUser: ClientUser = new ClientUser();
  isLender = false;
  isOther = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onConfirm(clientUser: SearchableItem): void {
    this.bsModalRef.hide();
    this.subject.next(clientUser);
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }
}
